import React from 'react';

import SvgIcon, { type Svg } from '../SvgIcon';

interface QualificationProps {
  icon: Svg;
  text: string;
}

const Qualification: React.FC<QualificationProps> = ({ icon, text }) => {
  return (
    <div className="mb-1 flex items-center justify-start space-x-3">
      <SvgIcon svgType={icon} className="size-4.5 text-leland-gray-light" />
      <p className="text-lg font-normal text-leland-gray-light">{text}</p>
    </div>
  );
};

export default Qualification;
